import { Controller } from "@hotwired/stimulus"

// Mostra/esconde grupos de campos conforme o valor do(s) input(s) `control`.
// Cada `group` declara em data-show-for os valores que o exibem (separados por
// vírgula). Por padrão, ao esconder um grupo limpa seus inputs — evita enviar
// valores ocultos e reseta Tom Select (el.tomselect.clear()); use clear-value=false
// para preservá-los. Não age no connect: o estado inicial vem renderizado pelo
// servidor; só reavalia a cada change.
export default class extends Controller {
  static targets = ["control", "group"]
  static values = { clear: { type: Boolean, default: true } }

  update() {
    const value = this._currentValue()
    this.groupTargets.forEach((group) => {
      const showFor = (group.getAttribute("data-show-for") || "").split(",")
      const show = showFor.includes(value)
      group.style.display = show ? "" : "none"
      if (!show && this.clearValue) this._clear(group)
    })
  }

  _currentValue() {
    const radios = this.controlTargets.filter((c) => c.type === "radio")
    if (radios.length) {
      const checked = radios.find((r) => r.checked)
      return checked ? checked.value : ""
    }
    return this.hasControlTarget ? this.controlTarget.value : ""
  }

  _clear(group) {
    group.querySelectorAll("input, select, textarea").forEach((el) => {
      if (el.tomselect) {
        el.tomselect.clear()
      } else {
        el.value = ""
      }
    })
  }
}
